import { WindowReferenceService } from '../window-reference/window-reference.service';
// See: https://stackoverflow.com/questions/34177221/angular2-how-to-inject-window-into-an-angular2-service
var WindowService = /** @class */ (function () {
    function WindowService(windowReferenceService) {
        this.windowReferenceService = windowReferenceService;
    }
    Object.defineProperty(WindowService.prototype, "localStorage", {
        get: function () {
            return this.window.localStorage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowService.prototype, "sessionStorage", {
        get: function () {
            return this.window.sessionStorage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowService.prototype, "window", {
        // noinspection JSMethodCanBeStatic
        get: function () {
            return this.windowReferenceService.window;
        },
        enumerable: true,
        configurable: true
    });
    // noinspection JSMethodCanBeStatic
    WindowService.prototype.scrollToTop = function () {
        this.window.scrollTo(0, 0);
    };
    return WindowService;
}());
export { WindowService };
